export const dropdownsConstants = {
  SET_DROPDOWNS_LOADING: 'dropdowns/SET_DROPDOWNS_LOADING',
  GET_COUNTRIES: 'dropdowns/GET_COUNTRIES',
  SET_COUNTRIES: 'dropdowns/SET_COUNTRIES',
  GET_OBJECT_NUMBERS: 'dropdowns/GET_OBJECT_NUMBERS',
  SET_OBJECT_NUMBERS: 'dropdowns/SET_OBJECT_NUMBERS',
  SET_DROPDOWNS_ERROR: 'dropdowns/SET_DROPDOWNS_ERROR',
};
